import jMoment from 'moment-jalaali';
import { FILTER_TYPES } from 'components/FilterPod';

const STATUS_OPTIONS = [
  {
    label: 'پرداخت نشده',
    value: 'NOT_PAYED',
  },
  {
    label: 'لغو شده قبل از پرداخت',
    value: 'CANCELED_BEFORE_PAYED',
  },
  {
    label: 'پرداخت شده',
    value: 'PAYED',
  },
  {
    label: 'بسته شده',
    value: 'CLOSED',
  },
  {
    label: 'مسترد شده',
    value: 'RETURNED',
  },
];


const filters = (guildOptions = [] , currencyText) => [
  {
    title: 'نوع تاریخ',
    label: 'نوع تاریخ',
    keyName: 'dateTimeType',
    id: 1384,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        { value: null, label: 'انتخاب نشده' },
        { value: 'ISSUANCE_DATE', label: 'تاریخ صدور' },
        { value: 'PAYMENT_DATE', label: 'تاریخ پرداخت' },
      ],
    },
  },

  {
    title: 'محدوده تاریخ',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',
    id: {
      start: null,
      end: null,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {
        maxDate: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
      end: {
        maxDate: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
    },
  },


  {
    title: 'محدوده‌ مبلغ قابل پرداخت',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    unit: currencyText,
    keyName: 'amountPayable',
    id: {
      start: 1350,
      end: 1351,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },

  {
    title: 'شناسه فاکتور',
    label: 'شناسه فاکتور',
    keyName: 'invoiceId',
    id: 1349,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },

  {
    title: 'براساس وضعیت فاکتور',
    label: 'وضعیت فاکتور',
    keyName: 'status',
    id: 1352,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: STATUS_OPTIONS,
    },
  },
  {
    title: 'بر اساس حساب تفصیلی',
    label: 'حساب تفصیلی',
    keyName: 'guildId',
    id: 1575,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: guildOptions,
    },
  },

  {
    title: 'براساس نوع پرداخت',
    label: 'نوع پرداخت',
    keyName: 'paymentType',
    id: 2430,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [],
    },
  }

];

export default filters;
